import { updateCancellationPolicyInfoContent } from "../../../actions/siteadmin/CancellationPolicy/updateCancelPolicy";

export default async function submit(values, dispatch) {
   await dispatch(updateCancellationPolicyInfoContent(values))


}